/**
 * 常用文件操作类工具函数
 * @author gabewu
 */

function openFile(url: string) {
  const el = document.createElement('a');
  el.setAttribute('href', url);
  el.setAttribute('target', '_blank');
  el.style.display = 'none';
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
}

function downloadFile(url: string, name: string) {
  const el = document.createElement('a');
  el.setAttribute('href', url);
  el.setAttribute('target', '_blank');
  el.setAttribute('download', name);
  el.style.display = 'none';
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
}

export default {
  openFile,
  downloadFile,
};
